export function isInIframe() {
  return window !== window.top;
}
